import { useState } from 'react';
import { FormContainer } from '../../../_core/form/form-container.component';
import { EditInviteNestedContainer, IEditInviteContainerProps } from './edit-invite-form-nested.container';
import { ICloseableDialogProps } from '../../../_core/core.types';

export const EditInviteContainer = (props: IEditInviteContainerProps & ICloseableDialogProps) => {
  const [success, setSuccess] = useState<string | null>(null);
  const [submitError, setSubmitError] = useState<string | null>(null);

  return (
    <FormContainer
      error={submitError}
      setError={setSubmitError}
      success={success}
      setSuccess={setSuccess}
      title="Edit Staff Invite"
    >
      <EditInviteNestedContainer
        {...props}
        onError={(e) => setSubmitError(e ?? null)}
        onSuccess={(s) => setSuccess(s ?? null)}
      />
    </FormContainer>
  );
};
